import { render, staticRenderFns } from "./formIntegracao.vue?vue&type=template&id=089693c0"
import script from "./formIntegracao.vue?vue&type=script&lang=js"
export * from "./formIntegracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports